export default __webpack_public_path__ + "static/media/AnimalPage1.9fe25fd3.txt";